/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";
export var roleTypeMap = {
  leader: '1',
  member: '2',
  user: '4'
};